import { ColumnsPreferenceRecognizedLists } from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { FilterGroupByEnum } from '../../filter/reportFilter.types';

export const PRODUCT_SALES_REPORT_COLUMNS_KEY = 'ps';

export const PRODUCT_COLOR_SALES_REPORT_COLUMNS_KEY = 'pcs';

export const PRODUCT_COLOR_DW_SALES_REPORT_COLUMNS_KEY = 'pcdws';

export const productSalesKeysToIgnore = [
  PRODUCT_SALES_REPORT_COLUMNS_KEY,
  PRODUCT_COLOR_SALES_REPORT_COLUMNS_KEY,
  PRODUCT_COLOR_DW_SALES_REPORT_COLUMNS_KEY,
];

export const PRODUCT_SALES_REPORT_COLUMNS_KEYS_BY_GROUP_BY = {
  [FilterGroupByEnum.PRODUCT]: PRODUCT_SALES_REPORT_COLUMNS_KEY,
  [FilterGroupByEnum.PRODUCT_COLOR]: PRODUCT_COLOR_SALES_REPORT_COLUMNS_KEY,
  [FilterGroupByEnum.PRODUCT_COLOR_DELIVERY_WINDOW]: PRODUCT_COLOR_DW_SALES_REPORT_COLUMNS_KEY,
};

export const PRODUCT_SALES_REPORT_LIST_BY_GROUP_BY = {
  [FilterGroupByEnum.PRODUCT]: ColumnsPreferenceRecognizedLists.REPORT_PRODUCT_SALES,
  [FilterGroupByEnum.PRODUCT_COLOR]: ColumnsPreferenceRecognizedLists.REPORT_PRODUCT_COLOR_SALES,
  [FilterGroupByEnum.PRODUCT_COLOR_DELIVERY_WINDOW]:
    ColumnsPreferenceRecognizedLists.REPORT_PRODUCT_COLOR_DELIVERY_WINDOW_SALES,
};
